import React, { useEffect, useState } from 'react';

import styled from 'styled-components';

import { Activity, BookingOption } from '../../types/Activity';
import { Order, OrderBookingOption } from '../../types/Order';
import FieldView from '../utils/FieldView';
import { getQuantity } from '../../infrastructure/utils/order';

import { mapItemsWithActivityBookingOptions } from './helpers';

const StyledOptionWrapper = styled.div`
  background-color: #f2f2f2;
  border-radius: 6px;
  margin-bottom: 10px;
  padding: 1px 10px 10px 10px;
`;

type Props = {
  order: Order;
  activity: Activity;
};
const BookingOptionFields = ({ order, activity }: Props) => {
  const [mappedOrderOptions, setMappedOrderOptions] = useState<
    Array<[OrderBookingOption, BookingOption | undefined]>
  >([]);

  useEffect(() => {
    setMappedOrderOptions(
      mapItemsWithActivityBookingOptions(order.bookingOptions || [], activity)
    );
  }, [order, activity]);

  const renderBookingOptions = () => {
    return (
      <>
        {mappedOrderOptions.map(optionSet => {
          const orderOption = optionSet[0];
          const activityOption = optionSet[1];
          const { id, attendees } = orderOption;
          const title = activityOption?.title;
          const isAtHome = activityOption?.locationType === 'atHome';
          const attendeesLength = `${getQuantity(
            attendees.length,
            activityOption?.pricingModel,
            activityOption?.subType
          )}x`;

          return activityOption ? (
            <StyledOptionWrapper key={id}>
              <FieldView name={attendeesLength}>{title}</FieldView>
              {isAtHome && (
                <>
                  <FieldView name='Address'>
                    {orderOption.location?.address || ''}
                  </FieldView>
                  {orderOption.location?.locationNotes && (
                    <FieldView name='Location notes'>
                      {orderOption.location?.locationNotes || ''}
                    </FieldView>
                  )}
                </>
              )}
            </StyledOptionWrapper>
          ) : (
            <>No booking options found</>
          );
        })}
      </>
    );
  };

  return (
    <div className='data-box'>
      <h4>
        <b>Booking Option(s)</b>
      </h4>
      {renderBookingOptions()}
    </div>
  );
};

export default React.memo(BookingOptionFields);
